import React, { useState } from 'react';
import { FilterBar } from '../components/FilterBar';
import { MetricCard } from '../components/MetricCard';
import { PerformanceTable } from '../components/PerformanceTable';
import { PhoneIcon, RepeatIcon, ClipboardCheckIcon, FileCheckIcon, SendIcon, CheckCircleIcon, UsersIcon, ShieldCheckIcon } from 'lucide-react';
// Mock user role - in production this would come from authentication context
const currentUserRole: 'admin' | 'manager' = 'manager';
const currentUserTeamSize = 5;
const mockAggregatedData = [{
  bucket: 'UML Internet Leads JP',
  dials: 1375,
  dialsTransferPercent: 0.4,
  transfers: 5,
  apps: 7,
  appDocPercent: 50,
  docs: 14,
  docSubPercent: 100,
  subs: 14,
  subClosingPercent: 0,
  closings: 12,
  totalCompensation: 36000,
  totalLoanAmount: 1500000,
  avgComp: 2.4,
  dialsRecords: [{
    id: 'DL-2024-001',
    borrowerName: 'John Smith',
    loanAmount: 350000,
    date: '2024-01-15',
    status: 'Active',
    propertyAddress: '123 Main St, Austin, TX'
  }, {
    id: 'DL-2024-002',
    borrowerName: 'Sarah Johnson',
    loanAmount: 425000,
    date: '2024-01-18',
    status: 'Active',
    propertyAddress: '456 Oak Ave, Dallas, TX'
  }, {
    id: 'DL-2024-003',
    borrowerName: 'Michael Chen',
    loanAmount: 280000,
    date: '2024-01-20',
    status: 'Pending',
    propertyAddress: '789 Pine Rd, Houston, TX'
  }],
  transfersRecords: [{
    id: 'TR-2024-001',
    borrowerName: 'John Smith',
    loanAmount: 350000,
    date: '2024-01-16',
    status: 'In Progress',
    propertyAddress: '123 Main St, Austin, TX'
  }, {
    id: 'TR-2024-002',
    borrowerName: 'Sarah Johnson',
    loanAmount: 425000,
    date: '2024-01-19',
    status: 'In Progress',
    propertyAddress: '456 Oak Ave, Dallas, TX'
  }],
  appsRecords: [{
    id: 'AP-2024-001',
    borrowerName: 'Emily Davis',
    loanAmount: 310000,
    date: '2024-01-17',
    status: 'Active',
    propertyAddress: '321 Elm St, San Antonio, TX'
  }, {
    id: 'AP-2024-002',
    borrowerName: 'David Wilson',
    loanAmount: 395000,
    date: '2024-01-20',
    status: 'Active',
    propertyAddress: '654 Maple Dr, Fort Worth, TX'
  }],
  docsRecords: [{
    id: 'DC-2024-001',
    borrowerName: 'Jennifer Martinez',
    loanAmount: 280000,
    date: '2024-01-18',
    status: 'Active',
    propertyAddress: '987 Cedar Ln, Plano, TX'
  }, {
    id: 'DC-2024-002',
    borrowerName: 'Robert Taylor',
    loanAmount: 340000,
    date: '2024-01-21',
    status: 'Pending',
    propertyAddress: '147 Birch Way, Irving, TX'
  }],
  subsRecords: [{
    id: 'SB-2024-001',
    borrowerName: 'Lisa Anderson',
    loanAmount: 315000,
    date: '2024-01-19',
    status: 'In Progress',
    propertyAddress: '258 Spruce Ct, Arlington, TX'
  }, {
    id: 'SB-2024-002',
    borrowerName: 'James Brown',
    loanAmount: 385000,
    date: '2024-01-22',
    status: 'In Progress',
    propertyAddress: '369 Willow St, Frisco, TX'
  }],
  closingsRecords: [{
    id: 'CL-2024-001',
    borrowerName: 'Patricia Garcia',
    loanAmount: 350000,
    date: '2024-01-20',
    status: 'Completed',
    propertyAddress: '741 Ash Blvd, McKinney, TX'
  }, {
    id: 'CL-2024-002',
    borrowerName: 'Christopher Lee',
    loanAmount: 425000,
    date: '2024-01-23',
    status: 'Completed',
    propertyAddress: '852 Poplar Ave, Allen, TX'
  }]
}, {
  bucket: 'Internet',
  dials: 1150,
  dialsTransferPercent: 2.6,
  transfers: 30,
  apps: 14,
  appDocPercent: 21.4,
  docs: 3,
  docSubPercent: 133.3,
  subs: 4,
  subClosingPercent: 75,
  closings: 3,
  totalCompensation: 9000,
  totalLoanAmount: 375000,
  avgComp: 2.4,
  dialsRecords: [{
    id: 'DL-2024-010',
    borrowerName: 'Amanda White',
    loanAmount: 125000,
    date: '2024-01-16',
    status: 'Active',
    propertyAddress: '963 Hickory Dr, Denton, TX'
  }, {
    id: 'DL-2024-011',
    borrowerName: 'Daniel Harris',
    loanAmount: 145000,
    date: '2024-01-19',
    status: 'Pending',
    propertyAddress: '159 Walnut St, Lewisville, TX'
  }],
  transfersRecords: [{
    id: 'TR-2024-010',
    borrowerName: 'Amanda White',
    loanAmount: 125000,
    date: '2024-01-17',
    status: 'In Progress',
    propertyAddress: '963 Hickory Dr, Denton, TX'
  }],
  appsRecords: [{
    id: 'AP-2024-010',
    borrowerName: 'Michelle Clark',
    loanAmount: 135000,
    date: '2024-01-18',
    status: 'Active',
    propertyAddress: '357 Sycamore Ln, Carrollton, TX'
  }],
  docsRecords: [],
  subsRecords: [{
    id: 'SB-2024-010',
    borrowerName: 'Kevin Rodriguez',
    loanAmount: 115000,
    date: '2024-01-20',
    status: 'Pending',
    propertyAddress: '753 Magnolia Way, Richardson, TX'
  }],
  closingsRecords: [{
    id: 'CL-2024-010',
    borrowerName: 'Nancy Lewis',
    loanAmount: 125000,
    date: '2024-01-21',
    status: 'Completed',
    propertyAddress: '951 Dogwood Ct, Garland, TX'
  }, {
    id: 'CL-2024-011',
    borrowerName: 'Steven Walker',
    loanAmount: 145000,
    date: '2024-01-24',
    status: 'Completed',
    propertyAddress: '357 Redwood Dr, Mesquite, TX'
  }]
}, {
  bucket: 'VA IRRRL Prospect',
  dials: 485,
  dialsTransferPercent: 1,
  transfers: 5,
  apps: 17,
  appDocPercent: 47.1,
  docs: 8,
  docSubPercent: 50,
  subs: 4,
  subClosingPercent: 50,
  closings: 2,
  totalCompensation: 4500,
  totalLoanAmount: 250000,
  avgComp: 1.8,
  dialsRecords: [{
    id: 'DL-2024-020',
    borrowerName: 'Brian Foster',
    loanAmount: 125000,
    date: '2024-01-17',
    status: 'Active',
    propertyAddress: '159 Beech St, Grand Prairie, TX'
  }],
  transfersRecords: [],
  appsRecords: [{
    id: 'AP-2024-020',
    borrowerName: 'Rachel Kim',
    loanAmount: 130000,
    date: '2024-01-19',
    status: 'Active',
    propertyAddress: '753 Fir Ave, Flower Mound, TX'
  }],
  docsRecords: [],
  subsRecords: [],
  closingsRecords: [{
    id: 'CL-2024-020',
    borrowerName: 'Thomas Wright',
    loanAmount: 125000,
    date: '2024-01-22',
    status: 'Completed',
    propertyAddress: '951 Juniper Ln, Coppell, TX'
  }, {
    id: 'CL-2024-021',
    borrowerName: 'Jessica Moore',
    loanAmount: 125000,
    date: '2024-01-25',
    status: 'Completed',
    propertyAddress: '357 Cypress Way, Grapevine, TX'
  }]
}, {
  bucket: 'List 2',
  dials: 433,
  dialsTransferPercent: 16.4,
  transfers: 71,
  apps: 12,
  appDocPercent: 83.3,
  docs: 10,
  docSubPercent: 40,
  subs: 4,
  subClosingPercent: 100,
  closings: 4,
  totalCompensation: 12000,
  totalLoanAmount: 500000,
  avgComp: 2.4,
  dialsRecords: [],
  transfersRecords: [],
  appsRecords: [],
  docsRecords: [],
  subsRecords: [],
  closingsRecords: [{
    id: 'CL-2024-030',
    borrowerName: 'Andrew Scott',
    loanAmount: 125000,
    date: '2024-01-16',
    status: 'Completed',
    propertyAddress: '753 Laurel Dr, Southlake, TX'
  }, {
    id: 'CL-2024-031',
    borrowerName: 'Victoria Adams',
    loanAmount: 125000,
    date: '2024-01-19',
    status: 'Completed',
    propertyAddress: '159 Hawthorn St, Colleyville, TX'
  }, {
    id: 'CL-2024-032',
    borrowerName: 'Ryan Mitchell',
    loanAmount: 125000,
    date: '2024-01-22',
    status: 'Completed',
    propertyAddress: '951 Chestnut Ave, Bedford, TX'
  }, {
    id: 'CL-2024-033',
    borrowerName: 'Olivia Parker',
    loanAmount: 125000,
    date: '2024-01-25',
    status: 'Completed',
    propertyAddress: '357 Pecan Ln, Euless, TX'
  }]
}, {
  bucket: 'List 1',
  dials: 332,
  dialsTransferPercent: 7.2,
  transfers: 24,
  apps: 9,
  appDocPercent: 44.4,
  docs: 4,
  docSubPercent: 50,
  subs: 2,
  subClosingPercent: 50,
  closings: 1,
  totalCompensation: 2800,
  totalLoanAmount: 175000,
  avgComp: 1.6,
  dialsRecords: [],
  transfersRecords: [],
  appsRecords: [],
  docsRecords: [],
  subsRecords: [],
  closingsRecords: [{
    id: 'CL-2024-040',
    borrowerName: 'Ethan Cooper',
    loanAmount: 175000,
    date: '2024-01-20',
    status: 'Completed',
    propertyAddress: '753 Cottonwood Way, Hurst, TX'
  }]
}, {
  bucket: 'UML Internet Leads A',
  dials: 273,
  dialsTransferPercent: 1.1,
  transfers: 3,
  apps: 3,
  appDocPercent: 66.7,
  docs: 2,
  docSubPercent: 100,
  subs: 2,
  subClosingPercent: 100,
  closings: 2,
  totalCompensation: 6500,
  totalLoanAmount: 260000,
  avgComp: 2.5,
  dialsRecords: [],
  transfersRecords: [],
  appsRecords: [],
  docsRecords: [],
  subsRecords: [],
  closingsRecords: [{
    id: 'CL-2024-050',
    borrowerName: 'Sophia Bennett',
    loanAmount: 130000,
    date: '2024-01-18',
    status: 'Completed',
    propertyAddress: '159 Basswood Dr, North Richland Hills, TX'
  }, {
    id: 'CL-2024-051',
    borrowerName: 'Mason Turner',
    loanAmount: 130000,
    date: '2024-01-23',
    status: 'Completed',
    propertyAddress: '951 Alder St, Keller, TX'
  }]
}, {
  bucket: 'List 3',
  dials: 233,
  dialsTransferPercent: 17.2,
  transfers: 40,
  apps: 1,
  appDocPercent: 0,
  docs: 0,
  docSubPercent: 0,
  subs: 0,
  subClosingPercent: 0,
  closings: 0,
  totalCompensation: 0,
  totalLoanAmount: 0,
  avgComp: 0,
  dialsRecords: [],
  transfersRecords: [],
  appsRecords: [],
  docsRecords: [],
  subsRecords: [],
  closingsRecords: []
}, {
  bucket: 'UML Internet Lead',
  dials: 213,
  dialsTransferPercent: 1.4,
  transfers: 3,
  apps: 4,
  appDocPercent: 50,
  docs: 2,
  docSubPercent: 0,
  subs: 0,
  subClosingPercent: 0,
  closings: 0,
  totalCompensation: 0,
  totalLoanAmount: 0,
  avgComp: 0,
  dialsRecords: [],
  transfersRecords: [],
  appsRecords: [],
  docsRecords: [],
  subsRecords: [],
  closingsRecords: []
}, {
  bucket: 'UML Internet Leads S',
  dials: 182,
  dialsTransferPercent: 0,
  transfers: 0,
  apps: 3,
  appDocPercent: 0,
  docs: 0,
  docSubPercent: 0,
  subs: 1,
  subClosingPercent: 0,
  closings: 0,
  totalCompensation: 0,
  totalLoanAmount: 0,
  avgComp: 0,
  dialsRecords: [],
  transfersRecords: [],
  appsRecords: [],
  docsRecords: [],
  subsRecords: [],
  closingsRecords: []
}, {
  bucket: 'VA IRRRL Data M',
  dials: 154,
  dialsTransferPercent: 0,
  transfers: 0,
  apps: 3,
  appDocPercent: 0,
  docs: 0,
  docSubPercent: 0,
  subs: 1,
  subClosingPercent: 0,
  closings: 0,
  totalCompensation: 0,
  totalLoanAmount: 0,
  avgComp: 0,
  dialsRecords: [],
  transfersRecords: [],
  appsRecords: [],
  docsRecords: [],
  subsRecords: [],
  closingsRecords: []
}];
const mockIndividualData = [{
  bucket: 'Lead Source A',
  teamMember: 'Sarah Johnson',
  dials: 275,
  dialsTransferPercent: 1.8,
  transfers: 5,
  apps: 3,
  appDocPercent: 66.7,
  docs: 2,
  docSubPercent: 100,
  subs: 2,
  subClosingPercent: 100,
  closings: 2,
  totalCompensation: 6500,
  totalLoanAmount: 260000,
  avgComp: 2.5,
  dialsRecords: [{
    id: 'DL-2024-101',
    borrowerName: 'Alex Thompson',
    loanAmount: 130000,
    date: '2024-01-15',
    status: 'Active',
    propertyAddress: '123 Valley View, Austin, TX'
  }, {
    id: 'DL-2024-102',
    borrowerName: 'Maria Gonzalez',
    loanAmount: 130000,
    date: '2024-01-20',
    status: 'Pending',
    propertyAddress: '456 Hill Crest, Dallas, TX'
  }],
  transfersRecords: [],
  appsRecords: [],
  docsRecords: [],
  subsRecords: [],
  closingsRecords: [{
    id: 'CL-2024-101',
    borrowerName: 'Alex Thompson',
    loanAmount: 130000,
    date: '2024-01-22',
    status: 'Completed',
    propertyAddress: '123 Valley View, Austin, TX'
  }, {
    id: 'CL-2024-102',
    borrowerName: 'Maria Gonzalez',
    loanAmount: 130000,
    date: '2024-01-25',
    status: 'Completed',
    propertyAddress: '456 Hill Crest, Dallas, TX'
  }]
}, {
  bucket: 'Lead Source B',
  teamMember: 'Michael Chen',
  dials: 230,
  dialsTransferPercent: 2.6,
  transfers: 6,
  apps: 4,
  appDocPercent: 50,
  docs: 2,
  docSubPercent: 100,
  subs: 2,
  subClosingPercent: 50,
  closings: 1,
  totalCompensation: 2800,
  totalLoanAmount: 175000,
  avgComp: 1.6,
  dialsRecords: [],
  transfersRecords: [],
  appsRecords: [],
  docsRecords: [],
  subsRecords: [],
  closingsRecords: [{
    id: 'CL-2024-110',
    borrowerName: 'Brian Foster',
    loanAmount: 175000,
    date: '2024-01-23',
    status: 'Completed',
    propertyAddress: '789 Park Lane, Houston, TX'
  }]
}, {
  bucket: 'Lead Source C',
  teamMember: 'Emily Rodriguez',
  dials: 310,
  dialsTransferPercent: 3.2,
  transfers: 10,
  apps: 5,
  appDocPercent: 60,
  docs: 3,
  docSubPercent: 133.3,
  subs: 4,
  subClosingPercent: 75,
  closings: 3,
  totalCompensation: 9000,
  totalLoanAmount: 375000,
  avgComp: 2.4,
  dialsRecords: [],
  transfersRecords: [],
  appsRecords: [],
  docsRecords: [],
  subsRecords: [],
  closingsRecords: [{
    id: 'CL-2024-120',
    borrowerName: 'Rachel Kim',
    loanAmount: 125000,
    date: '2024-01-19',
    status: 'Completed',
    propertyAddress: '321 River Rd, San Antonio, TX'
  }, {
    id: 'CL-2024-121',
    borrowerName: 'Thomas Wright',
    loanAmount: 125000,
    date: '2024-01-22',
    status: 'Completed',
    propertyAddress: '654 Lake Dr, Fort Worth, TX'
  }, {
    id: 'CL-2024-122',
    borrowerName: 'Jessica Moore',
    loanAmount: 125000,
    date: '2024-01-26',
    status: 'Completed',
    propertyAddress: '987 Forest Ave, Plano, TX'
  }]
}, {
  bucket: 'Lead Source D',
  teamMember: 'David Thompson',
  dials: 195,
  dialsTransferPercent: 1.0,
  transfers: 2,
  apps: 2,
  appDocPercent: 50,
  docs: 1,
  docSubPercent: 100,
  subs: 1,
  subClosingPercent: 100,
  closings: 1,
  totalCompensation: 3200,
  totalLoanAmount: 150000,
  avgComp: 2.1,
  dialsRecords: [],
  transfersRecords: [],
  appsRecords: [],
  docsRecords: [],
  subsRecords: [],
  closingsRecords: [{
    id: 'CL-2024-130',
    borrowerName: 'Andrew Scott',
    loanAmount: 150000,
    date: '2024-01-24',
    status: 'Completed',
    propertyAddress: '147 Mountain View, Irving, TX'
  }]
}, {
  bucket: 'Lead Source E',
  teamMember: 'Jessica Martinez',
  dials: 420,
  dialsTransferPercent: 4.3,
  transfers: 18,
  apps: 8,
  appDocPercent: 62.5,
  docs: 5,
  docSubPercent: 80,
  subs: 4,
  subClosingPercent: 100,
  closings: 4,
  totalCompensation: 12000,
  totalLoanAmount: 500000,
  avgComp: 2.4,
  dialsRecords: [],
  transfersRecords: [],
  appsRecords: [],
  docsRecords: [],
  subsRecords: [],
  closingsRecords: [{
    id: 'CL-2024-140',
    borrowerName: 'Victoria Adams',
    loanAmount: 125000,
    date: '2024-01-17',
    status: 'Completed',
    propertyAddress: '258 Sunset Blvd, Arlington, TX'
  }, {
    id: 'CL-2024-141',
    borrowerName: 'Ryan Mitchell',
    loanAmount: 125000,
    date: '2024-01-20',
    status: 'Completed',
    propertyAddress: '369 Sunrise Way, Frisco, TX'
  }, {
    id: 'CL-2024-142',
    borrowerName: 'Olivia Parker',
    loanAmount: 125000,
    date: '2024-01-23',
    status: 'Completed',
    propertyAddress: '741 Meadow Ln, McKinney, TX'
  }, {
    id: 'CL-2024-143',
    borrowerName: 'Ethan Cooper',
    loanAmount: 125000,
    date: '2024-01-26',
    status: 'Completed',
    propertyAddress: '852 Garden St, Allen, TX'
  }]
}];
export function Dashboard() {
  const [sliceBy, setSliceBy] = useState('lead-source');
  const [timeframe, setTimeframe] = useState('today');
  const [topN, setTopN] = useState(10);
  const [viewMode, setViewMode] = useState<'aggregated' | 'individual'>('aggregated');
  const handleRefresh = () => {
    console.log('Refreshing data...');
  };
  const currentData = viewMode === 'aggregated' ? mockAggregatedData : mockIndividualData;
  const totalDials = currentData.reduce((sum, row) => sum + row.dials, 0);
  const totalTransfers = currentData.reduce((sum, row) => sum + row.transfers, 0);
  const totalApps = currentData.reduce((sum, row) => sum + row.apps, 0);
  const totalDocs = currentData.reduce((sum, row) => sum + row.docs, 0);
  const totalSubs = currentData.reduce((sum, row) => sum + row.subs, 0);
  const totalClosings = currentData.reduce((sum, row) => sum + row.closings, 0);
  return <div className="min-h-screen w-full bg-gradient-to-br from-gray-50 to-gray-100" data-id="element-151">
      <div className="max-w-[1600px] mx-auto px-6 py-8" data-id="element-152">
        {/* Header */}
        <div className="mb-8" data-id="element-153">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-3" data-id="element-154">
            <div data-id="element-155">
              <h1 className="text-4xl font-bold text-gray-900 tracking-tight mb-1" data-id="element-156">
                Performance Dashboard
              </h1>
              <p className="text-base text-gray-600" data-id="element-157">
                {currentUserRole === 'manager' ? "Track your team's loan pipeline metrics and pull-through rates" : 'Track loan pipeline metrics and pull-through rates by lead source'}
              </p>
            </div>
            <div className="flex items-center gap-3" data-id="element-158">
              {currentUserRole === 'manager' && <div className="flex items-center gap-2 px-4 py-2.5 bg-blue-50 border border-blue-200 rounded-lg shadow-sm" data-id="element-159">
                  <UsersIcon className="h-4 w-4 text-blue-600" aria-hidden="true" data-id="element-160" />
                  <span className="text-sm font-semibold text-blue-900" data-id="element-161">
                    Team: {currentUserTeamSize} members
                  </span>
                </div>}
              <div className="flex items-center gap-2 px-4 py-2.5 bg-white border border-gray-300 rounded-lg shadow-sm" data-id="element-162">
                <ShieldCheckIcon className="h-4 w-4 text-gray-600" aria-hidden="true" data-id="element-163" />
                <span className="text-sm font-semibold text-gray-900 capitalize" data-id="element-164">
                  {currentUserRole}
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Filter Bar */}
        <FilterBar sliceBy={sliceBy} timeframe={timeframe} topN={topN} viewMode={viewMode} onSliceByChange={setSliceBy} onTimeframeChange={setTimeframe} onTopNChange={setTopN} onViewModeChange={setViewMode} onRefresh={handleRefresh} data-id="element-165" />

        {/* Metric Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4 mb-8" data-id="element-166">
          <MetricCard label="Dials" value={totalDials} icon={<PhoneIcon className="h-5 w-5 text-blue-600" aria-hidden="true" data-id="element-168" />} data-id="element-167" />
          <MetricCard label="Transfers" value={totalTransfers} icon={<RepeatIcon className="h-5 w-5 text-blue-600" aria-hidden="true" data-id="element-170" />} data-id="element-169" />
          <MetricCard label="Apps Taken" value={totalApps} icon={<ClipboardCheckIcon className="h-5 w-5 text-blue-600" aria-hidden="true" data-id="element-172" />} data-id="element-171" />
          <MetricCard label="Docs Out" value={totalDocs} icon={<FileCheckIcon className="h-5 w-5 text-blue-600" aria-hidden="true" data-id="element-174" />} data-id="element-173" />
          <MetricCard label="Submissions" value={totalSubs} icon={<SendIcon className="h-5 w-5 text-blue-600" aria-hidden="true" data-id="element-176" />} data-id="element-175" />
          <MetricCard label="Closings" value={totalClosings} icon={<CheckCircleIcon className="h-5 w-5 text-blue-600" aria-hidden="true" data-id="element-178" />} data-id="element-177" />
        </div>

        {/* Performance Table */}
        <div className="mb-4" data-id="element-179">
          <h2 className="text-2xl font-bold text-gray-900 mb-1" data-id="element-180">
            {viewMode === 'individual' ? 'Individual Team Member Performance' : `Top ${topN} by ${sliceBy.split('-').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ')}`}
          </h2>
          <p className="text-sm text-gray-600" data-id="element-181">
            {timeframe === 'today' ? 'Today' : timeframe.split('-').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ')}
          </p>
        </div>
        <PerformanceTable data={currentData.slice(0, topN)} viewMode={viewMode} data-id="element-182" />
      </div>
    </div>;
}